const SET_PVZ = (state, payload) => {
    state.pvz_selected = payload
}
const SET_PVZ_OBJ = (state, payload) => {
    state.pvz_obj_selected = payload
}
const SET_DELIV_TYPE_GROUP = (state, payload) => {
    state.deliv_type_group = payload
}
const SET_DELIV_TYPE_ID = (state, payload) => {
    state.deliv_type_id = payload
}
const SET_DELIV_REGION_ID = (state, payload) => {
    state.deliv_region_id = payload
}
const SET_DELIV_CITY_ID = (state, payload) => {
    state.deliv_city_id = payload
}
const SET_DELIV_DAY = (state, payload) => {
    state.deliv_day = payload
}
const SET_DELIV_DAY_SAM = (state, payload) => {
    state.deliv_day_sam = payload
}
const SET_DELIV_INTERVAL = (state, payload) => {
    state.deliv_interval = payload
}
const SET_USER_INFO = (state, payload) => {
    state.user_info = payload
}
const SET_PAY_TYPE = (state, payload) => {
    state.pay_type = payload
}
const SET_PVZS = (state, payload) => {
    state.pvzs = payload
}
const SET_COORDINATES = (state, payload) => {
    state.coordinates = payload
}
const SET_DELIV_COUNTRY = (state, payload) => {
    state.deliv_country = payload
}
const SET_DELIV_REGION = (state, payload) => {
    state.deliv_region = payload
}
const SET_DELIV_CITY = (state, payload) => {
    state.deliv_city = payload
}
const SET_DELIV_ZIP = (state, payload) => {
    state.deliv_zip = payload
}
const SET_REQUIRE_ADDRESS = (state, payload) => {
    state.require_address = payload
}
const SET_REQUIRE_PASSPORT = (state, payload) => {
    state.require_passport = payload
}

export default {
    SET_PVZ,
    SET_PVZ_OBJ,
    SET_DELIV_TYPE_GROUP,
    SET_DELIV_TYPE_ID,
    SET_DELIV_REGION_ID,
    SET_DELIV_CITY_ID,
    SET_DELIV_DAY,
    SET_DELIV_DAY_SAM,
    SET_DELIV_INTERVAL,
    SET_USER_INFO,
    SET_PAY_TYPE,
    SET_PVZS,
    SET_COORDINATES,
    SET_DELIV_COUNTRY,
    SET_DELIV_REGION,
    SET_DELIV_CITY,
    SET_DELIV_ZIP,
    SET_REQUIRE_ADDRESS,
    SET_REQUIRE_PASSPORT
}
